import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "fs-5 fw-semobold mb-2 required" }
const _hoisted_3 = ["value"]

import { ref } from "vue";
import RebateService from "../services/RebateService";
import SiderDetail from "@/components/SiderDetail.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'RebateDetail',
  setup(__props, { expose: __expose }) {

const isLoading = ref(true);
const submited = ref(false);
const rebates = ref({} as any);
const rebateDetailShowRef = ref<InstanceType<typeof SiderDetail>>();

const criteria = ref({
  Id: 0,
});

const show = async (_id: number) => {
  rebateDetailShowRef.value?.show();

  try {
    criteria.value.Id = _id;
    const responseBody = await RebateService.getTradeFromRebate(criteria.value);
    rebates.value = responseBody.data;
    criteria.value = responseBody.criteria;

    isLoading.value = false;
  } catch (error) {
    console.log(error);
  }
};

const submit = async () => {
  isLoading.value = true;
};

const close = () => {
  rebateDetailShowRef.value?.hide();
};

__expose({ show });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SiderDetail, {
    save: submit,
    discard: close,
    title: _ctx.$t('action.edit'),
    elId: "rebate_detail_show",
    isLoading: isLoading.value,
    submited: submited.value,
    isDisabled: false,
    savingTitle: _ctx.$t('action.saving'),
    "show-footer": false,
    width: "{default:'40%'}",
    ref_key: "rebateDetailShowRef",
    ref: rebateDetailShowRef
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rebates.value[0], (item, key) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "col-4 mb-5",
            key: key
          }, [
            _createElementVNode("label", _hoisted_2, _toDisplayString(key), 1),
            _createElementVNode("input", {
              class: "form-control form-control-solid",
              placeholder: "",
              name: "rate",
              value: item,
              disabled: ""
            }, null, 8, _hoisted_3)
          ]))
        }), 128))
      ])
    ]),
    _: 1
  }, 8, ["title", "isLoading", "submited", "savingTitle"]))
}
}

})